/**
 * retourner le host courant
 *
 * par exemple sur https://formations-secretaire-medicale.fr/ on aura formations-secretaire-medicale.fr
 */
export const getCurrentHost = (): string => {
  if (window?.location?.hostname !== undefined) {
    return window.location.hostname;
  }
  console.error(
    'Error getting current host: window or window.location is not available',
  );
  return 'lecolefrancaise.fr';
};

/**
 * function qui retourne l'origin du site
 */
export const getCurrentOrigin = (): string => {
  try {
    return window.location.origin;
  } catch (error) {
    console.error('Error getting the current origin:', error);
    return 'https://lecolefrancaise.fr';
  }
};
